/**
 * FloatingWidgets - 浮动视频小窗 + 全屏视频弹窗 + 底部购物车浮动栏
 * shortVideos数据由Mpro.liquid页面传入
 */
var FloatingWidgets = {
  showVideoWidget: true,
  isModalOpen: false,
  currentVideoIndex: 0,
  isModalMuted: false,

  shortVideos: [],

  init: function () {
    var self = this;

    // Scroll listener for floating cart bar
    window.addEventListener('scroll', function () {
      var cartBar = document.getElementById('floatingCartBar');
      if (!cartBar) return;

      if (window.scrollY > 600 && !self.isModalOpen) {
        cartBar.classList.remove('translate-y-full');
        cartBar.classList.add('translate-y-0');
      } else {
        cartBar.classList.add('translate-y-full');
        cartBar.classList.remove('translate-y-0');
      }
    });

    // Build product card for initial video
    this.renderProductCard(0);
  },

  openVideoModal: function () {
    this.isModalOpen = true;
    this.isModalMuted = false;

    // 暂停小窗视频，避免两个视频同时播放
    var widgetVideo = document.querySelector('#floatingVideoWidget video');
    if (widgetVideo) widgetVideo.pause();

    var modal = document.getElementById('videoModal');
    if (modal) modal.classList.remove('hidden');
    document.body.style.overflow = 'hidden';

    this.updateMuteIcon();

    // Update video source
    var videoEl = document.getElementById('modalVideoEl');
    if (videoEl) {
      videoEl.src = this.shortVideos[this.currentVideoIndex].src;
      videoEl.muted = false;
      videoEl.load();
      videoEl.play().catch(function () {});
    }

    this.renderProductCard(this.currentVideoIndex);
  },

  closeVideoModal: function () {
    this.isModalOpen = false;
    var modal = document.getElementById('videoModal');
    if (modal) modal.classList.add('hidden');
    document.body.style.overflow = '';

    // 暂停弹窗视频并静音
    var modalVideo = document.getElementById('modalVideoEl');
    if (modalVideo) {
      modalVideo.pause();
      modalVideo.muted = true;
    }

    // 恢复小窗视频静音循环播放
    var widgetVideo = document.querySelector('#floatingVideoWidget video');
    if (widgetVideo) {
      widgetVideo.muted = true;
      widgetVideo.play().catch(function () {});
    }
  },

  toggleMute: function () {
    this.isModalMuted = !this.isModalMuted;
    this.updateMuteIcon();

    var videoEl = document.getElementById('modalVideoEl');
    if (videoEl) {
      videoEl.muted = this.isModalMuted;
    }
  },

  updateMuteIcon: function () {
    var icon = document.getElementById('modalMuteIcon');
    if (!icon) return;
    if (this.isModalMuted) {
      icon.setAttribute('data-lucide', 'volume-x');
    } else {
      icon.setAttribute('data-lucide', 'volume-2');
    }
    if (typeof lucide !== 'undefined') lucide.createIcons();
  },

  nextVideo: function () {
    this.currentVideoIndex = (this.currentVideoIndex + 1) % this.shortVideos.length;
    this.switchVideo();
  },

  prevVideo: function () {
    this.currentVideoIndex = (this.currentVideoIndex - 1 + this.shortVideos.length) % this.shortVideos.length;
    this.switchVideo();
  },

  switchVideo: function () {
    var video = this.shortVideos[this.currentVideoIndex];
    var videoEl = document.getElementById('modalVideoEl');

    if (videoEl) {
      videoEl.src = video.src;
      videoEl.muted = this.isModalMuted;
      videoEl.load();
      videoEl.play().catch(function () {});
    }

    this.renderProductCard(this.currentVideoIndex);
  },

  renderProductCard: function (index) {
    var card = document.getElementById('modalProductCard');
    if (!card) return;

    var video = this.shortVideos[index];
    var html = '<div class="flex gap-4 items-center mb-4">';
    html += '<div class="w-16 h-16 rounded-xl overflow-hidden bg-gray-100 flex-shrink-0 border border-gray-200">';
    html += '<img src="' + video.product.image + '" alt="Product" class="w-full h-full object-cover" />';
    html += '</div>';
    html += '<div class="flex-1 min-w-0">';
    html += '<h4 class="text-[13px] md:text-sm font-bold text-gray-900 leading-tight mb-1 line-clamp-2">' + video.product.name + '</h4>';
    html += '<div class="text-lg font-black text-gray-900">$' + video.product.price.toFixed(2) + '</div>';
    html += '</div></div>';
    html += '<button class="w-full bg-[#FAFAFA] border border-gray-200 hover:bg-gray-100 hover:border-gray-300 text-gray-900 font-bold py-3 rounded-xl text-sm transition-all active:scale-[0.98]">ADD TO CART</button>';

    card.innerHTML = html;
  },

  hideVideoWidget: function (e) {
    e.stopPropagation();
    this.showVideoWidget = false;
    var widget = document.getElementById('floatingVideoWidget');
    if (widget) widget.classList.add('hidden');
  }
};
